import React, { useContext } from 'react';
import TextButton from '../../../TextButton';
import { ToastContext } from '../../../Toast/ToastContext';
const ToastAction = ({ dataHook, onClick, children }) => {
    const toastHidden = useContext(ToastContext)?.hidden ?? false;
    return (React.createElement(TextButton, { dataHook: dataHook, skin: "light", size: "medium", underline: "always", onClick: onClick, disabled: toastHidden }, children));
};
export default ToastAction;
//# sourceMappingURL=ToastAction.js.map